import { jsx, Fragment } from 'react/jsx-runtime';
import classNames from 'classnames';
import { SkeletonBox } from '../../../SkeletonBox/SkeletonBox.es.js';
import { Table } from '../../Table.es.js';
import { useTableContext } from '../../Table.Context/index.es.js';

const SKELETON_SIZES = [
    4,
    9,
    5,
    7,
    6
];
const TableBodyLoader = ({ className, numRows })=>{
    const [{ numLoadingColumns }] = useTableContext();
    // Num columns will update after table renders
    if (numLoadingColumns == null) return null;
    return jsx(Fragment, {
        children: Array(numRows).fill(null).map((_, i)=>jsx(Table.Body.Row, {
                className: classNames(className, 'cb-table-body-loader'),
                children: Array(numLoadingColumns).fill(null).map((_, j)=>{
                    const cellIndex = numLoadingColumns * i + j;
                    const width = `w-${SKELETON_SIZES[cellIndex % SKELETON_SIZES.length]}/12`;
                    return jsx(Table.Body.Cell, {
                        children: jsx(SkeletonBox, {
                            className: `${width}`
                        })
                    }, j);
                })
            }, i))
    });
};
TableBodyLoader.displayName = 'Table.Body.Loader';

export { TableBodyLoader };
//# sourceMappingURL=Table.Body.Loader.es.js.map
